import React from 'react'
import Navbar from '../components/Navbar';
import Footer from './Footer';
import Products from './Products';

const MainPage = () => {
  return (
    <div >
      <Navbar/>
      <Products/>
      <Footer/>
      
    </div>
  )
}

export default MainPage